// *** ILF - Remove Terrific live shopping pop-up on /pages/live-shopping page

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname !== '/pages/live-shopping') return;

  /* OLD FUNCTION
  const removeTerrific = () => {
    document.querySelector('div[data-source="terrific"]')?.remove();
    document.querySelector('#terrific-minimize-pop-up-button')?.remove();
  };*/

  const removeTerrific = () => {
  document
    .querySelector('div[data-source="terrific"][embedding-id="XnBKBYudG98SaRPmZiQR"]')?.remove();
  document.querySelector('#terrific-minimize-pop-up-button')?.remove();
};

  // Run once
  removeTerrific();

  // In case Terrific loads late
  const observer = new MutationObserver(removeTerrific);
  observer.observe(document.body, { childList: true, subtree: true });
});
